<h2 mat-dialog-title>Confirmar</h2>
<mat-dialog-content class="mat-typography">
  <h3>¿Eliminar?</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>
